export const doc_purchases_es = {
  title: "Compras",
  description_1: `Como usuario gratuito de Piper tenés las siguientes limitaciones en cada uno de estos recursos:
`,
  limit_albums: "300 álbumes",
  limit_collections: "3 colecciones",
  limit_shelvings: "2 muebles",
  limit_artists: "200 artistas",
  limit_labels: "200 sellos",
  limit_album_formats: "10 formatos de álbum",
  limit_album_types: "10 tipos de álbum",
  limit_tags: "30 etiquetas",
  limit_stores: "50 tiendas",
  limit_sell_values: "50 valores de venta",
  limit_exchange_rates: "100 cambios de moneda",
  description_2: `
En el momento que llegues a cualquiera de estos límites, el sistema te va a avisar que llegaste al máximo para ese recurso cuando quieras agregar un nuevo ítem. Siempre tenés la opción de eliminar un ítem para agregar uno distinto en cualquier momento.

Si querés extender cualquiera de estos límites, tenés la posibilidad de realizar una compra. Cada recurso cuenta con distintos paquetes que, al comprarlos, van a extender el límite en determinada cantidad. Vas a poder encontrar el menú de compra de cada recurso en tu perfil de usuario, en la tabla que indica tus límites actuales.

La acreditación del nuevo límite es inmediata una vez que se realiza el pago de forma exitosa.

Para usar el medio de pago de Apple Pay es necesario que uses la aplicación nativa de iOS disponible en App Store. El monto puede diferir entre medios de pago.

Ante cualquier problema con una compra, no dudes en consultar a soporte para que podamos corregir tu situación lo antes posible.

`
};
